import {EmptyLayout} from '../../containers/Common';

const NotFound = () => {
  return <EmptyLayout>
    <h1>404 Page Not Found</h1>
  </EmptyLayout>;
}

export default NotFound;